<div class="innerContainer">
    <div class="provider-status-dashboard">
        <div class="font-weight-bold grpHeader"><a
                (click)="groupPortalDataService.navigateToRoute('myGroup')">Invoices</a></div>
        <div class="divider"></div>
        <div class="payment-methods-dashboard container p-0 widgetBodyContainer">

            <div class="row headerRow-nb">
                <div class="col-3">
                    <strong>Date</strong>
                </div>
                <div class="col">
                    <strong>Group Bill Number</strong>
                </div>
                <!-- <div class="col">
                <strong>Status</strong>
            </div> -->
                <div class="col-3 d-inline-flex justify-content-end">
                    <strong>Amount</strong>
                </div>
            </div>
            <div class="divider-3 darker"></div>
            <div class="row cardInfo" *ngFor="let invoice of groupInvoices | limitTo : 4"
                [hidden]="invoice.status != 'Submitted'">
                <div class="col-3">
                    {{SantizeDate(invoice.date)}}
                </div>
                <div class="col">
                    <!-- <a href="#" title="Group Bill Number">{{invoice.groupBillNumber}}</a> -->
                    {{invoice.groupBillNumber}}
                </div>
                <!-- <div class="col py-2">
                        {{invoice.status}}
                    </div> -->
                <div class="col-3 d-inline-flex justify-content-end">
                    <strong>{{invoice.amount | currency:'USD':'symbol-narrow':'1.2-2'}}</strong>
                </div>
            </div>

            <div class="row cardInfo" *ngIf="groupInvoices?.length < 1">
                <div class="col-12">
                    <i>Currently No Invoices to Display</i>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button class="btn greyBtn right" (click)="groupPortalDataService.navigateToRoute('history')">View
                        More</button>
                </div>
            </div>
        </div>
    </div>
    <div class="widgetLoader {{invoicesDoneProcessing ? 'hidethis' : ''}}"></div>
</div>